import React from 'react';

import { TpDashboardElement, TpDashboardContext, TpDashboardSequenceLayoutDefinition } from '../dashboard/interfaces';
import { TpDataContext } from '../../../data/interfaces';
import { renderDashboardElement } from '../dashboard/render-elem';
import { dashboardWidgetPadding } from '../dashboard/layout-hints';
import { useAppDispatch } from '../../../app/hooks';
import { ElementEditTools } from '../dashboard/edit-mode/ElementEditTools';

interface TpDashboardSequenceLayoutProps {
  parentElemDef: TpDashboardElement | null;
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  elemDef: TpDashboardSequenceLayoutDefinition;
}

function DashboardSequenceLayout({
  dataContext,
  parentElemDef,
  elemDef,
  dashboardContext,
}: TpDashboardSequenceLayoutProps) {
  const dispatch = useAppDispatch();

  const totalPadding = elemDef.elements.length * dashboardWidgetPadding;

  const spacer = (
    <div style={{ display: 'inline-block', backgroundColor: 'transparent', width: `${dashboardWidgetPadding}px` }} />
  );

  const width = dashboardContext.editMode ? 'calc(100% - 60px)' : '100%';

  const style: any = { width: '100%', minHeight: '100px', position: 'relative' };
  if (dashboardContext.editMode) {
    style.border = '1px dashed rgb(255,128,0)';
    style.boxSizing = 'border-box';
  }
  return (
    <div style={style}>
      <div style={{ width, height: '100%', display: 'inline-block' }}>
        {elemDef.elements.map((el, idx) => (
          <React.Fragment key={`idx_${idx}`}>
            <div
              style={{
                width: `calc(${((el as any).elemLayoutHints?.sizeXRelative || 1) * 100}% - ${
                  totalPadding / elemDef.elements.length
                }px)`,
                height: '100%',
                display: 'inline-block',
                whiteSpace: 'normal',
                verticalAlign: 'top',
                marginBottom: '30px',
              }}
            >
              {renderDashboardElement(elemDef, el, dataContext, dashboardContext)}
            </div>
            {idx < elemDef.elements.length - 1 && spacer}
          </React.Fragment>
        ))}
        {dashboardContext.editMode && (
          <ElementEditTools
            dataContext={dataContext}
            dashboardContext={dashboardContext}
            parentElemDef={parentElemDef}
            elemDef={elemDef}
            dispatch={dispatch}
          />
        )}
      </div>
    </div>
  );
}

export default DashboardSequenceLayout;
